import React, { useEffect, useRef, useState } from "react";
import { Badge } from "reactstrap";
import { useHover } from "ahooks";
import { GET_LABEL_WITH_STATUS, PROCESS_STATUS, PROCESS_STATUS_NAME } from "src/constant/common";
import "react-tooltip/dist/react-tooltip.css";
import TooltipWrapper from "../TooltipWrapper";

const LabelStatus = ({
  row,
  field = "status",
  staticTooltip,
  errorList,
  containerClass,
  content,
  showWarningIcon = false,
  warningContent = "",
}) => {
  const labelRef = useRef();
  const isHovering = useHover(labelRef);
  const [tooltip, setTooltip] = useState("");

  useEffect(() => {
    if (isHovering && row?.status === PROCESS_STATUS.ERROR && staticTooltip) {
      setTooltip(staticTooltip);
    }
  }, [isHovering]);

  return (
    <div ref={labelRef} className={`position-relative ${containerClass}`}>
      <TooltipWrapper id={`status-${row?.id}`} tooltipText={tooltip} show={row?.status === PROCESS_STATUS.ERROR && tooltip}>
        <BadgeWrapper
          color={GET_LABEL_WITH_STATUS[row?.status]}
          className="px-2 py-0 d-flex align-items-center justify-content-center flex-column width-by-px-110 height-by-px-36 f-s-13"
        >
          {content || PROCESS_STATUS_NAME[row?.status]}
        </BadgeWrapper>
      </TooltipWrapper>
      {showWarningIcon && (
        <TooltipWrapper
          id={`file-status-${row?.id}`}
          tooltipText={warningContent || ""}
          tooltipClassName="max-width-by-px-300"
          placement="top"
        >
          <div className="warning-mark">
            <i className="bi bi-exclamation-circle f-s-20 px-1" />
          </div>
        </TooltipWrapper>
      )}
    </div>
  );
};

const BadgeWrapper = React.forwardRef((props, ref) => <Badge innerRef={ref} {...props} />);

LabelStatus.propTypes = {};

export default LabelStatus;
